module.exports = __webpack_public_path__ + "static/media/2.31a7a2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/2.png
// module id = 973
// module chunks = 0